export { IconContainer, Content, Container } from '../portal-card/styled';

/**
 * This height has to be same as Card title font size (h500).
 */
export const titleSkeletonHeight = '21px';
